/**
 * Surfaces `scope_degraded`.
 *
 * When a GitLab membership lookup fails while resolving a caller's scope,
 * the backend still responds (fail-closed, never wider than the caller's
 * real access) but narrows silently to self-scope. A project lead in that
 * state sees only their own usage; a small number then reads as "my team
 * used nothing" unless this is visible. See `SummaryResponse.scope_degraded`
 * in `backend/features/ai_gateway/schemas.py`.
 */

import { type ReactElement } from 'react';

interface ScopeBannerProps {
  degraded: boolean;
}

export function ScopeBanner({ degraded }: ScopeBannerProps): ReactElement | null {
  if (!degraded) return null;

  return (
    <div className="usage-scope-banner" role="alert">
      Project data unavailable — showing your own usage only. A GitLab lookup failed while
      resolving your team&apos;s projects, so this view may be narrower than what you actually
      have access to.
    </div>
  );
}
